<script lang="ts" setup>import { computed as _computed } from 'vue';

import { Link } from '@inertiajs/vue3'
import { isSameApp } from '@shared/url'

withDefaults(defineProps<{
  href?: string
}>(), {  })

const attrs = useAttrs()

const tag = _computed(() => {
  if (attrs.download || attrs.target || (__props.href && !isSameApp(__props.href)) || String(__props.href).startsWith('mailto:')) return 'a'
  if (!__props.href) return 'button'
  return Link
})
</script>

<template>
  <component :is="tag" v-bind="$props">
    <slot/>
  </component>
</template>
